import { render, staticRenderFns } from "./AddVersionModal.vue?vue&type=template&id=4a8602c4&scoped=true"
import script from "./AddVersionModal.vue?vue&type=script&lang=js"
export * from "./AddVersionModal.vue?vue&type=script&lang=js"
import style0 from "./AddVersionModal.vue?vue&type=style&index=0&id=4a8602c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8602c4",
  null
  
)

export default component.exports